<template>
    <ul class="nav-smart-phone" :style="style">
        <li class="gnav-menu-item first-child" v-show="drawer">
            <i class="el-icon-close" @click="closeNav"></i>
        </li>
        <li class="gnav-menu-item icon-about-me" @click="closeNav">
            <router-link class="router-link gtm_guronabi_first_g" tag="div" to="/about-me">
                <p class="gtm_guronabi_first_g">初めての方へ</p>
            </router-link>
        </li>
        <li class="gnav-menu-item has-child xrU9jla12j">
            <div class="sp-menu-open router-link">
                <div class="notification-icon-container">
                    <MessageNotification v-if="isMemberHasNewMessage.hasNewMessage" value="new"></MessageNotification>
                    <p>相続お役立ちツール</p>
                </div>
            </div>
            <ul class="submenu">
                <li class="submenu-item stationTax-bg" @click="closeNav">
                    <router-link class="router-link gtm_guronabi_byoudewakaru_g" tag="div" to="/stationTax">
                        <div class="submenu-item-main">
                            <p class="gtm_guronabi_byoudewakaru_g">10秒でわかる相続税</p>
                        </div>
                    </router-link>
                </li>
                <li class="submenu-item icon-book" @click="closeNav">
                    <router-link class="router-link gtm_guronabi_yonndewakaru_g" tag="div" to="/category">
                        <div class="submenu-item-main">
                            <p class="gtm_guronabi_yonndewakaru_g">読んでわかる相続</p>
                        </div>
                    </router-link>
                </li>
                <li class="submenu-item icon-calculation" @click="closeNav">
                    <router-link class="router-link gtm_guronabi_kantankeisan_g" tag="div" to="/calculation/tax">
                        <div class="submenu-item-main">
                            <p class="gtm_guronabi_kantankeisan_g">相続税かんたん計算</p>
                        </div>
                    </router-link>
                </li>
                <li class="submenu-item icon-my" @click="closeNav">
                    <router-link class="router-link gtm_guronabi_lifeplan_g" tag="div" to="/life-event-simulator" >
                        <div class="submenu-item-main">
                            <p class="gtm_guronabi_lifeplan_g">My家族年表</p>
                        </div>
                    </router-link>
                </li>
                <li class="submenu-item icon-bua" @click="closeNav">
                    <router-link class="router-link gtm_guronabi_momedo_g" tag="div" to="/diagnosis">
                        <div class="submenu-item-main">
                            <p class="gtm_guronabi_momedo_g">相続モメ度診断～モメない先の杖～</p>
                        </div>
                    </router-link>
                </li>
                <li class="submenu-item icon-seminar" @click="closeNav">
                    <router-link class="router-link gtm_guronabi_seminar_g" tag="div" to="/seminar">
                        <div class="submenu-item-main">
                            <p class="gtm_guronabi_seminar_g">セミナー案内</p>
                        </div>
                    </router-link>
                </li>
                <li class="submenu-item icon-checklist" @click="closeNav">
                    <router-link class="router-link gtm_guronabi_checklist_g" tag="div" to="/invoiceFlag">
                        <div class="submenu-item-main">
                            <p class="gtm_guronabi_checklist_g">相続手続きチェックリスト</p>
                        </div>
                    </router-link>
                 </li>
                <li class="submenu-item icon-download" @click="closeNav">
                    <router-link class="router-link" tag="div" to="/download">
                        <div class="submenu-item-main">
                            <p>資料ダウンロード</p>
                        </div>
                    </router-link>
                </li>
            </ul>
        </li>
        <li class="gnav-menu-item icon-email" @click="closeNav">
            <div class="router-link" @click="openLoginDialog('anken')">
                <p>ご依頼一覧</p>
            </div>
        </li>
        <li class="gnav-menu-item icon-computer" @click="closeNav">
            <div class="router-link" @click="openLoginDialog('memberInfo')">
                <p>会員情報</p>
            </div>
        </li>
    </ul>
</template>
<script>
import { mapGetters } from 'vuex'
import MessageNotification from '../chat/MessageNotification'
import { SET_OPEN_LOGIN_DIALOG } from '@/store/actions.type'
import { isIE } from '@/common/useragent'
export default {
    computed: {
        ...mapGetters(['isAuthenticated', 'isMemberHasNewMessage'])
    },
    components: {
        'MessageNotification': MessageNotification
    },
    methods: {
        closeNav () {
            this.$emit('close-nav')
        },
        showErrMsg () {
            this.$alert('この機能を使うにはまずはお問い合わせください', '', {
                confirmButtonText: 'OK'
            })
        },
        openLoginDialog (routeName) {
            localStorage.setItem('routeName', routeName)
            this.$store.dispatch(SET_OPEN_LOGIN_DIALOG, true)
        }
    },
    props: {
        drawer: Boolean
    },
    created () {
        if (!this.drawer) {
            if (isIE()) {
                this.style = 'display: flex; justify-content: space-around'
            } else {
                this.style = 'display: flex; justify-content: space-evenly'
            }
        }
    },
    data () {
        return {
            style: ''
        }
    }
}
</script>
